import React from 'react';
import { useHistory } from 'react-router-dom';

const NotFound = () => {
  const history = useHistory();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-gray-800">
      <h1 className="text-9xl font-extrabold text-red-600 tracking-widest">404</h1>
      <div className="bg-red-600 px-2 text-sm rounded rotate-12 absolute">
        Page Not Found
      </div>
      <h2 className="text-3xl font-semibold mt-8 mb-2 text-center md:text-4xl">
        Halaman Tidak Ditemukan
      </h2>
      <p className="text-gray-500 mb-8 px-4 text-center text-lg md:text-xl max-w-lg">
        Maaf, halaman yang Anda cari mungkin telah dihapus, namanya diganti, atau tidak tersedia untuk sementara waktu.
      </p>
      <button
        onClick={() => history.push('/')}
        className="px-8 py-3 bg-red-600 text-white text-lg font-medium rounded-full shadow-lg hover:bg-red-700 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-red-300 transition transform hover:-translate-y-1 active:translate-y-0"
      >
        Kembali ke Beranda
      </button>
    </div>
  );
};

export default NotFound;
